module.exports = __webpack_public_path__ + "static/media/400396_02.92895a25.png";